module.exports = __webpack_public_path__ + "img/outline-error.f6df8535.svg";